module.exports = __webpack_public_path__ + "img/Server1.8024ed1.svg";